import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import {
    MANAGEMENT_COMMON_I_ACCEPT,
    MANAGEMENT_CANCEL_TEXT,
} from "app/pages/sales-intelligence/pages/management/translations/managementKeys";
import {
    MANAGEMENT_SF_TERMS_MODAL_DETAILS,
    MANAGEMENT_SF_TERMS_MODAL_TITLE,
} from "app/pages/sales-intelligence/pages/management/translations/modals";
import {
    CUSTOM_TERMS_STYLES,
    StyledTermsModalHeader,
    StyledTermsModalText,
    StyledTermsDetails,
    CUSTOM_TERMS_CONFIRM_STYLES,
    CUSTOM_TERMS_DETAILS_STYLES,
} from "../../../styles/modal";
import type { ModalProps } from "./types";
import { ManagementModal } from "app/pages/sales-intelligence/common-components/modals/ManagementModal/ManagementModal";
import { INTEGRATION_TERMS } from "app/pages/sales-intelligence/pages/management/constants/constants";

export default function TermsModal({ integrationName, isOpen, onConfirm, onClose }: ModalProps) {
    const translate = useTranslation();

    return (
        <ManagementModal
            customStyles={CUSTOM_TERMS_STYLES}
            confirmBtnText={MANAGEMENT_COMMON_I_ACCEPT}
            title={
                <StyledTermsModalHeader>
                    <StyledTermsModalText>{translate(MANAGEMENT_SF_TERMS_MODAL_TITLE)}</StyledTermsModalText>
                </StyledTermsModalHeader>
            }
            details={
                <StyledTermsDetails>
                    <p>{translate(MANAGEMENT_SF_TERMS_MODAL_DETAILS)}</p>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href={INTEGRATION_TERMS[integrationName]}
                    >
                        {INTEGRATION_TERMS[integrationName]}
                    </a>
                </StyledTermsDetails>
            }
            isOpen={isOpen}
            onConfirm={onConfirm}
            onClose={onClose}
            cancelBtnText={MANAGEMENT_CANCEL_TEXT}
            confirmBtnType="primary"
            cancelBtnType="flat"
            customConfirmStyles={CUSTOM_TERMS_CONFIRM_STYLES}
            customDetailsStyles={CUSTOM_TERMS_DETAILS_STYLES}
        />
    );
}
